module.exports = __webpack_public_path__ + "media/features/activity-analysis-detail-a60e1439.jpg";